module.exports = __webpack_public_path__ + "static/media/10-integrar.04f87c81.png";